import { Alert, Flex, Typography } from "antd"
import { useTranslation } from "react-i18next"

import Button from "../../../../../../Components/Button"
import RecoverConfigureBanner from "../../../../../../Components/RecoverConfigureBanner"
import Icon from "../../../../../../Icon"

import styles from "./activationBanner.module.less"

const { Text } = Typography

// Whichever banner the page's current state calls for. Exactly one renders, so the
// inquiries note below can ride inside it instead of stacking a second look-alike
// info alert.
//
// Inquiries are exempt from every auto-submission rule on this page (threshold,
// exceptions, low-value ignore alike): answering an inquiry fast is what stops it
// from becoming a formal dispute, so holding one back is never useful.
const ActivationBanner = ({
  pendingActivation,
  isActivated,
  pendingChanges,
  onConfirmChanges,
  onBackToSummary
}) => {
  const { t } = useTranslation()

  const inquiriesNote = (
    <Text>
      <Text strong>{t("Auto-submission rules apply to disputes only")}</Text>
      {": "}
      {t(
        "inquiries are always submitted automatically, whatever is configured below. A fast inquiry response is what stops it from becoming a formal dispute."
      )}
    </Text>
  )

  if (pendingActivation)
    return (
      <Alert
        type="info"
        showIcon
        className={styles.activateBanner}
        icon={<Icon type="settings" style={{ fontSize: 20 }} />}
        message={<Text strong>{t("Set up your Preferences")}</Text>}
        description={
          <Flex vertical gap={8}>
            <Text>
              {t(
                "Adjust the settings below. When you're ready, activate Recover from the setup summary."
              )}
            </Text>
            {inquiriesNote}
          </Flex>
        }
        action={<Button onClick={onBackToSummary} text={t("Back to Summary")} />}
      />
    )

  if (isActivated)
    return (
      <Alert
        type="info"
        showIcon
        className={styles.activateBanner}
        icon={<Icon type="circle_info" style={{ fontSize: 20 }} />}
        message={<Text strong>{t("Changing your Preferences?")}</Text>}
        description={
          <Flex vertical gap={8}>
            <Text>
              {t(
                "Make your changes below, then confirm them. Changes apply to the next disputes you receive, not to disputes already in your queue."
              )}
            </Text>
            {inquiriesNote}
          </Flex>
        }
        action={
          <Button
            type="primary"
            disabled={!pendingChanges}
            onClick={onConfirmChanges}
            text={t("Confirm changes")}
          />
        }
      />
    )

  // The Configure nudge is not an info Alert, so here the inquiries note keeps its own
  // banner without creating a twin.
  return (
    <>
      <RecoverConfigureBanner />
      <Alert
        type="info"
        showIcon
        className={styles.activateBanner}
        icon={<Icon type="circle_info" style={{ fontSize: 20 }} />}
        message={<Text strong>{t("Auto-submission rules apply to disputes only")}</Text>}
        description={
          <Text>
            {t(
              "Inquiries are always submitted automatically, whatever is configured below: a fast inquiry response is what stops it from becoming a formal dispute."
            )}
          </Text>
        }
      />
    </>
  )
}

export default ActivationBanner
